export enum DateRenderMode {
    Text = 'TEXT',
    SingleText = 'SINGLE_TEXT',
    Picklist = 'PICKLIST'
}
